import Avatar from './components/Avatar';

export default Avatar;
